var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.venueModel.getDescription())?_c('section',{staticClass:"view-venue-description"},[_c('p',[_vm._v(_vm._s(_vm.venueModel.getDescription()))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }